import { render, staticRenderFns } from "./ConfirmRecover.vue?vue&type=template&id=3ef42163&"
import script from "./ConfirmRecover.vue?vue&type=script&lang=js&"
export * from "./ConfirmRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports